export const Rules = {
  Actions: {
    TESTER: 'tester',
  },
};
